import { subject } from "@casl/ability";
import { Can } from "@dashboard/casl/taskAbility";
import { useHseInstance } from "@dashboard/hooks/useHseInstance";
import { faPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useNavigate } from "@tanstack/react-router";
import { Button } from "frontend-components";
import { useTranslation } from "react-i18next";

type NewListButtonProps = {
    iconOnly?: boolean;
    template?: boolean;
    className?: string;
};

export function NewListButton({
    iconOnly = false,
    template = false,
    className,
}: NewListButtonProps) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { instanceId } = useHseInstance();

    const openCreateModal = () => {
        void navigate({
            to: ".",
            search: (prev) => ({
                ...prev,
                list: "new",
                editList: undefined,
                listTemplate: template ? 1 : undefined,
            }),
        });
    };

    const label = t(template ? "list.newTemplateTitle" : "list.newListTitle");

    return (
        <Can I="create" this={subject("TaskList", { instanceId })}>
            {iconOnly ? (
                <Button
                    type="button"
                    variant="fill"
                    size="arrow"
                    aria-label={label}
                    className={className}
                    onClick={openCreateModal}
                >
                    <FontAwesomeIcon icon={faPlus} />
                </Button>
            ) : (
                <Button
                    type="button"
                    variant="fill"
                    className={className}
                    onClick={openCreateModal}
                >
                    <FontAwesomeIcon icon={faPlus} className="mr-2" />
                    {label}
                </Button>
            )}
        </Can>
    );
}
